export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-02_.1961df08.jpg";